export enum MissingInfoTypes {
    none = 0,
    outstanding_question = 5,
    missing_document = 2,
}